import { useEffect } from 'react';

export const usePatchForm = (item, setFieldValue): void => {
  useEffect(() => {
    if (item && setFieldValue) {
      Object.keys(item).forEach((key) => setFieldValue(key, item[key]));
    }
  }, [item, setFieldValue]);
};
